import { createSlice } from "@reduxjs/toolkit";
import { fetchSelfHostAgency } from "../services/hostAgencies";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const agency = createSlice({
  name: "hostAgencies",
  initialState,
  reducers: {
    fetchStarted: (state) => {
      state.isLoading = true;
    },
    fetchFulfilled: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchRejected: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// fetch Thunk
const fetch = () => async (dispatch) => {
  const { fetchStarted, fetchFulfilled, fetchRejected } = agency.actions;

  console.log("fetch dispatched...");

  dispatch(fetchStarted());

  try {
    const res = await fetchSelfHostAgency();
    dispatch(fetchFulfilled(res));
    return res;
  } catch (err) {
    dispatch(fetchRejected(err));
  }
};

export const actions = {
  ...agency.actions,
  fetch,
};

// selectors;
export const isLoading = (state) => state.isLoading;
export const getHostAgency = (state) => state.data;
export const isHostNotFound = ({ error }) =>
  error && error.response && error.response.status === 404;
export const getError = (state) => state.error;

export default agency.reducer;
